import { render } from "./AddSupernaturalMapModal.vue?vue&type=template&id=1bb4f8b4&scoped=true"
import script from "./AddSupernaturalMapModal.vue?vue&type=script&lang=js"
export * from "./AddSupernaturalMapModal.vue?vue&type=script&lang=js"

import "./AddSupernaturalMapModal.vue?vue&type=style&index=0&id=1bb4f8b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb4f8b4"]])

export default __exports__